module.exports = __webpack_public_path__ + "static/media/border2.f5778d3f.svg";